var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * A simple semaphore for controlling access to some shared resource,
 * allows at most `maxConcurrency` tasks to be executed concurrently.
 *
 * @param maxConcurrency
 * @returns A semaphore that allows for a maximum number of concurrent tasks to be executed
 */
export const createSemaphore = (maxConcurrency) => {
    const queue = [];
    let current = 0;
    let pending = 0;
    function executeNext() {
        const next = queue.shift();
        if (next === undefined) {
            return;
        }
        pending -= 1;
        current += 1;
        void next().finally(() => {
            current -= 1;
            executeNext();
        });
    }
    return {
        get executing() {
            return current;
        },
        get pending() {
            return pending;
        },
        get maxConcurrency() {
            return maxConcurrency;
        },
        execute(fn) {
            return __awaiter(this, void 0, void 0, function* () {
                if (current < maxConcurrency) {
                    current += 1;
                    try {
                        return yield fn();
                    }
                    finally {
                        current -= 1;
                        executeNext();
                    }
                }
                pending += 1;
                return yield new Promise((resolve, reject) => {
                    queue.push(() => fn().then(resolve, reject));
                });
            });
        },
    };
};
//# sourceMappingURL=semaphore.js.map